import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectDirectDebitBankAccountsAreLoading} from '../../../../data/direct-debit-account'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import DirectDebitAccountSummary, {
  DirectDebitAccountSummaryPageProps,
} from './DirectDebitAccountSummary'
import {SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectBankAccountSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_CREATE} from '../../../../routes/constants'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>
): Pick<DirectDebitAccountSummaryPageProps, 'isLoading' | 'bankAccountSummary' | 'isReadonly'> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS) ===
    FeInputFieldStatus.VERIFIED
  return {
    isLoading: selectDirectDebitBankAccountsAreLoading(state),
    // @ts-expect-error to be fixed
    bankAccountSummary: selectBankAccountSummaryData(state),
    isReadonly: isVerified || companyIsLocked,
  }
}

const mapDispatchToProps = {
  createBankAccount: (): any =>
    aPush(generatePath(ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_CREATE, {})),
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DirectDebitAccountSummary)
